import React from "react";

export const PhoneIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none">
      <path
        d="M13.9999 25.9529C20.5274 25.9529 25.9529 20.5274 25.9529 13.9999C25.9529 7.46088 20.5154 2.04688 13.9879 2.04688C7.44936 2.04687 2.04736 7.46088 2.04736 13.9999C2.04736 20.5274 7.46086 25.9529 13.9999 25.9529ZM10.9419 16.9179C8.03536 14.0229 6.18386 10.3319 8.37536 8.14038C8.50436 8.01137 8.64486 7.88288 8.77386 7.75388C9.44186 7.12088 10.0864 7.15638 10.6604 7.96488L12.1839 10.1329C12.6994 10.8829 12.5704 11.3044 12.0199 11.8904L11.5394 12.4179C11.3639 12.5819 11.4344 12.8044 11.5159 12.9454C11.7389 13.3669 12.3714 14.1169 13.0509 14.7969C13.7544 15.4999 14.4689 16.0974 14.9144 16.3434C15.0784 16.4374 15.3129 16.4609 15.4654 16.3204L15.9689 15.8399C16.5314 15.2889 16.9889 15.1484 17.7154 15.6639C18.4493 16.1858 19.1877 16.7015 19.9304 17.2109C20.6684 17.7499 20.8439 18.4179 20.0939 19.0974C19.9654 19.2264 19.8479 19.3674 19.7189 19.4959C17.5279 21.6759 13.8479 19.8239 10.9419 16.9179Z"
        fill="white"
      />
    </svg>
  );
};
